//
// Original collection by Kjetil Midtgarden Golid
// https://github.com/kgolid/chromotome
// https://kgolid.github.io/chromotome-site/
//
export default [
  {
    name: 'empusa',
    colors: ['#c92a28', '#e69301', '#1f8793', '#13652b', '#e7d8b0', '#48233b', '#e3b3ac'],
    stroke: '#1a1a1a',
    background: '#f0f0f2',
    type: 'flourish',
  },
  {
    name: 'delphi',
    colors: ['#475b62', '#7a999c', '#2a1f1d', '#fbaf3c', '#df4a33', '#f0e0c6', '#af592c'],
    stroke: '#2a1f1d',
    background: '#f0e0c6',
    type: 'flourish',
  },
  {
    name: 'mably',
    colors: ['#13477b', '#2f1b10', '#d18529', '#d72a25', '#e42184', '#138898', '#9d2787', '#7f311b'],
    stroke: '#2a1f1d',
    background: '#dfc792',
    type: 'flourish',
  },
  {
    name: 'nowak',
    colors: ['#e85b30', '#ef9e28', '#c6ac71', '#e0c191', '#3f6279', '#ee854e', '#180305'],
    stroke: '#180305',
    background: '#ede4cb',
    type: 'flourish',
  },
  {
    name: 'jupiter',
    colors: ['#c03a53', '#edd09e', '#aab5af', '#023629', '#eba735', '#8e9380', '#6c4127'],
    stroke: '#12110f',
    background: '#e6e2d6',
    type: 'flourish',
  },
  {
    name: 'hersche',
    colors: ['#df9f00', '#1f6f50', '#8e6d7f', '#da0607', '#a4a5a7', '#d3d1c3', '#42064f', '#25393a'],
    stroke: '#0a0a0a',
    background: '#f0f5f6',
    type: 'flourish',
  },
  {
    name: 'cherfi',
    colors: ['#99cb9f', '#cfb610', '#d00701', '#dba78d', '#2e2c1d', '#bfbea2', '#d2cfaf'],
    stroke: '#332e22',
    background: '#e3e2c5',
    type: 'flourish',
  },
  {
    name: 'harvest',
    colors: ['#313a42', '#9aad2e', '#f0ae3c', '#df4822', '#8eac9b', '#cc3d3f', '#ec8b1c', '#1b9268'],
    stroke: '#463930',
    background: '#e5e2cf',
    type: 'flourish',
  },
  {
    name: 'honey',
    colors: ['#f14d42', '#f4fdec', '#4fbe5d', '#265487', '#f6e916', '#f9a087', '#2e99d6'],
    stroke: '#141414',
    background: '#f4fdec',
    type: 'flourish',
  },
  {
    name: 'jungle',
    colors: ['#adb100', '#e5f4e9', '#f4650f', '#4d6838', '#cb9e00', '#689c7d', '#e2a1a8', '#151c2e'],
    stroke: '#0e0f27',
    background: '#cecaa9',
    type: 'flourish',
  },
  {
    name: 'skyspider',
    colors: ['#f4b232', '#f2dbbd', '#01799c', '#e93e48', '#0b1952', '#006748', '#ed817d'],
    stroke: '#050505',
    background: '#f0dbbc',
    type: 'flourish',
  },
  {
    name: 'atlas',
    colors: ['#5399b1', '#f4e9d5', '#de4037', '#ed942f', '#4e9e48', '#7a6e62'],
    stroke: '#3d352b',
    background: '#f0c328',
    type: 'flourish',
  },
  {
    name: 'giftcard',
    colors: [
      '#FBF5E9',
      '#FF514E',
      '#FDBC2E',
      '#4561CC',
      '#2A303E',
      '#6CC283',
      '#A71172',
      '#238DA5',
      '#9BD7CB',
      '#231E58',
      '#4E0942',
    ],
    stroke: '#000',
    background: '#FBF5E9',
    type: 'flourish',
  },
  {
    name: 'giftcard_sub',
    colors: ['#FBF5E9', '#FF514E', '#FDBC2E', '#4561CC', '#2A303E', '#6CC283', '#238DA5', '#9BD7CB'],
    stroke: '#000',
    background: '#FBF5E9',
    type: 'flourish',
  },
];
